<template>

  <v-content class="home" v-if="homeLoading">
    <home-skeleton></home-skeleton>
  </v-content>

  <v-content class="home" v-else>
    <app-loading-overlay v-if="sendMsgLoading"></app-loading-overlay>
    <main-banner></main-banner>
    <explore-banner></explore-banner>
    <contact-banner></contact-banner>
  </v-content>

</template>

<script>
import HomeSkeleton from "@/components/home/HomeSkeleton";
import MainBanner from "@/components/home/MainBanner";
import ExploreBanner from "@/components/home/ExploreBanner";
import ContactBanner from "@/components/home/ContactBanner";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    homeSkeleton: HomeSkeleton,
    mainBanner: MainBanner,
    exploreBanner: ExploreBanner,
    contactBanner: ContactBanner
   },
  data() {
    return {};
  },
  beforeMount() {
    this.fetchHomeData();
  },
  mounted() {
    this.logEvent("page_load", { 
      pageName: "home",
      lang: this.$i18n.locale 
    });
  },
  computed: {
    ...mapGetters(["loading", "sendMsgLoading", "homeLoading"])
  },
  methods: {
    ...mapActions(["fetchHomeData"])
  },
  metaInfo() {
    return {
      title: "Dr. Rashmee Rajkarnikar - Home",
      meta: [
        {
          name: "description",
          content: "Home page of official website of Dr. Rashmee Rajkarnikar. This page contains basic introduction to the website and possibility to navigate to the desired pages. The user can also contact the website owner via this page."
        },
        {
          property: "og:title",
          content: "Dr. Rashmee Rajkarnikar - Home"
        },
        {
          property: "og:site_name",
          content: "Dr. Rashmee Rajkarnikar"
        },
        {
          property: "og:description",
          content: "Learn, Practice, Communicate. For getting instant access to study materials navigate to the respective folder and download."
        },
        {
          property: "og:type",
          content: "website"
        },
        {
          property: "og:url",
          content: "https://dr-rashmee.com/en/"
        },
        {
          property: "og:image",
          content: "https://firebasestorage.googleapis.com/v0/b/newecohelp.appspot.com/o/aboutMe%2Frashmee.jpg?alt=media&token=026c4ef9-ed03-4ea9-8d57-060796352a88"
        }
      ]
    }
  }
};
</script>

<style>
.home {
  padding-top: 0px !important;
}
.fullWidthBanner {
    min-width: 100%;
    padding-top: 20px;
}
.homeBanner {
  padding: 5%;
}
</style>
